<template>
  <Toast/>
  <div class="py-4 container-fluid">
    <div class="mt-4 row">
      <div class="col-12">
        <div class="card">
          <!-- Card header -->
          <div class="card-header border-bottom">
            <div class="row d-flex align-items-center">
              <div class="col-6">
                <h5 class="mb-0">Ingatlan Módosítása - {{ realestate?.name }}</h5>
              </div>
              <div class="col-6 text-end d-flex justify-content-end gap-4">
                <material-button class="float-right btn btm-sm" @click="this.$router.push({ name: 'RealEstates List' })"
                                 @click.prevent="handleEdit" :loading="loading">
                  Mentés
                </material-button>
                <material-button class="float-right btn btm-sm" @click="this.$router.push({ name: 'RealEstates List' })"
                                 color="secondary">
                  Vissza
                </material-button>
              </div>
            </div>
          </div>
          <!--Card body-->
          <div class="card-body">
            <div class="relative">
              <MergeRealEstatesAreasModal :isModalForMergeOpen="isModalForMergeOpen" @close="closeModal"
                                          :selectedareas="selectedareas" :realestateId="realestateId"
                                          @updateAreas="addNewArea"
                                          @removeAreas="deleteOldAreas"/>

              <SeparateRealEstatesAreasModal :isModalForSeparateOpen="isModalForSeparateOpen" @close="closeModal"
                                             :selectedareas="selectedareas" :realestateId="realestateId"
                                             @editAreas="addNewAreas"
                                             @editNetFloorSpace="editAreaNetGrossFloorSpace"
                                             @removeAreas="deleteOldAreas"/>

              <!--<div class="button_plus" id="showButton" color="dark" variant="ghost" @click="visible = !visible" />-->
              <CCollapse :visible="visible" style="position: relative; top: 20px;">
                <CCard class="mt-3">
                  <CCardBody>
                    <div>
                      <div class="table-responsive">
                        <div class="info-rows mb-5 table-responsive">
                          <table v-if="realestate" class="table table-bordered" style="background-color: #d6e4f0;">
                            <tr>
                              <td class="text-center"><strong>{{ realestate?.name }}</strong></td>
                              <td class="text-center">{{ calculateRentableUnits(areas) }} DB [ BÉRBEADHATÓ EGYSÉG ]</td>
                              <td class="text-center">{{ formatArea(calculateCommonArea(areas)) }} [ KÖZÖS TERÜLET ]
                              </td>
                              <td class="text-center">{{ formatArea(realestate.gross_size) }} [ ÉPÍTMÉNY TERÜLET ]</td>
                              <td class="text-center"><strong>{{
                                  realestate.reconstruction ? formatDate(realestate.reconstruction) + ' [ÁTÉPÍTÉS]' : '-'
                                }}</strong></td>
                            </tr>
                            <tr>
                              <td class="text-center">{{ formatPercentage(calculateUtilization(realestate)) }} [
                                HASZNOSÍTHATÓSÁG ]
                              </td>
                              <td class="text-center">{{ formatArea(calculateRentableArea(areas)) }} [ BÉRBEADHATÓ
                                TERÜLET ]
                              </td>
                              <td class="text-center">{{ formatArea(calculateOperationalArea(areas)) }} [ ÜZEMELTETÉSI
                                TERÜLET ]
                              </td>
                              <td class="text-center">{{ formatArea(calculateFilledArea(areas)) }} [ FELTÖLTÖTT TERÜLET
                                ]
                              </td>
                              <td class="text-center">{{ formatPercentage(calculateProcessingRate(realestate, areas)) }}
                                [ FELDOLGOZOTTSÁG ]
                              </td>
                            </tr>
                          </table>
                        </div>
                        <!-- Table-->
                        <DataTable ref="dt" v-model:selection="selectedareas" :value="areas" dataKey="id"
                                   :paginator="true" :rows="10" :filters="filters"
                                   paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                                   :rowsPerPageOptions="[5, 10, 25, 50]"
                                   currentPageReportTemplate="{first} - {last} a {totalRecords} helységből"
                                   resizableColumns
                                   columnResizeMode="fit">
                          <template #header>
                            <Toolbar class="mb-2 w-xl-100 w-md-60 ">
                              <template #center>
                                <div class="my-4">
                                  <div
                                      class="w-xl-100 w-md-60 d-flex flex-column flex-lg-row gap-4 justify-content-between">
                                    <div
                                        class="d-flex flex-row align-items-lg-center justify-content-between gap-4 mt-3">
                                      <div class="w-lg-auto bg-body-secondary">
                                        <div class="d-flex align-items-center">
                                          <IconField class="w-100">
                                            <InputIcon>
                                              <i class="pi pi-search"></i>
                                            </InputIcon>
                                            <InputText
                                                v-model="filters['global'].value"
                                                placeholder="Keresés..."
                                                class="form-control w-100"
                                            />
                                          </IconField>
                                        </div>
                                      </div>
                                      <Button
                                          label="Helyiség Hozzáadása"
                                          icon="pi pi-plus"
                                          @click="openNew"
                                      />
                                    </div>
                                    <div class="d-flex flex-row align-items-lg-center gap-4 mt-3">
                                      <Button
                                          label="Átalakítás"
                                          icon="pi pi-building"
                                          severity="danger"
                                          outlined
                                          class="w-100 w-lg-auto"
                                          @click="openModal(selectedareas)"
                                          :disabled="(selectedareas === null) || ((selectedareas?.length ?? 0) < 1)"
                                      />
                                      <Button
                                          label="Export"
                                          icon="pi pi-upload"
                                          severity="secondary"
                                          class="w-100 w-lg-auto"
                                          @click="exportCSV($event)"
                                      />
                                    </div>
                                  </div>
                                  <div class="row mt-3 d-none d-lg-block align-items-start w-xl-100 w-md-60">
                                    <MultiSelect
                                        :modelValue="selectedColumns"
                                        :options="columns"
                                        optionLabel="header"
                                        class="w-xl-100 w-md-60"
                                        @update:modelValue="onToggle"
                                        display="chip"
                                        placeholder="Válasszon megjelenítendő oszlopot"
                                        size="small"/>
                                  </div>
                                </div>
                              </template>
                            </Toolbar>
                          </template>

                          <Column selectionMode="multiple" style="width: 3rem" :exportable="false"></Column>
                          <Column v-for="(col, index) of selectedColumns" :field="col.field" :header="col.header"
                                  :key="col.field + '_' + index" sortable>
                            <template v-if="col.field == 'area_buildings_id'" #body="slotProps">
                              <div>
                                {{ slotProps.data.area_buildings[0].name }}
                              </div>
                            </template>
                            <template v-if="col.field == 'area_numbers_id'" #body="slotProps">
                              <div>
                                {{ slotProps.data.area_numbers[0].name }}
                              </div>
                            </template>
                            <template v-if="col.field == 'area_functions_id'" #body="slotProps">
                              <div>
                                {{ slotProps.data.area_function[0].name }}
                              </div>
                            </template>
                            <template v-if="col.field == 'area_positions_id'" #body="slotProps">
                              <div>
                                {{ slotProps.data.area_position[0].name }}
                              </div>
                            </template>
                            <template v-if="col.field == 'area_floor_coverings_id'" #body="slotProps">
                              <div>
                                {{ slotProps.data.area_floor_covering[0].name }}
                              </div>
                            </template>
                            <template v-if="col.field == 'height'" #body="slotProps">
                              <div>
                                {{ slotProps.data.height ? slotProps.data.height + ' m' : '-' }}
                              </div>
                            </template>
                            <template v-if="col.field == 'wall_structure_id'" #body="slotProps">
                              <div>
                                {{ slotProps.data.area_wall_structures?.[0]?.name || '-' }}
                              </div>
                            </template>
                          </Column>
                          <Column :exportable="false" style="min-width: 12rem">
                            <template #body="slotProps">
                              <Button icon="pi pi-pencil" outlined rounded class="mr-2"
                                      @click="editarea(slotProps.data)"/>
                              <Button icon="pi pi-trash" outlined rounded severity="danger"
                                      @click="confirmDeletearea(slotProps.data)"/>
                            </template>
                          </Column>
                        </DataTable>
                      </div>

                      <Dialog v-model:visible="areaDialog" :style="{ width: '650px' }" header="Helység adatok"
                              :modal="true">
                        <div class="flex flex-col" style="display: flex;flex-direction: column; gap: 1rem;">
                          <div class="row">
                            <div class="col-md-6 mb-1">
                              <label for="identifier" class="block font-bold mb-3"
                                     style="display: block; font-weight: 700;">Bérlemény azonostó</label>
                              <InputText id="identifier" v-model.trim="area.identifier" required="true" autofocus
                                         :invalid="submitted && !area.identifier" fluid class="w-full"
                                         placeholder="(Kötelező)"/>
                              <small v-if="submitted && !area.identifier" class="text-red-500">Azonostó
                                szükséges.</small>
                            </div>
                            <div class="col-md-6 mb-1">
                              <label for="rental_utilization_id" class="block font-bold mb-3"
                                     style="display: block; font-weight: 700;">Bérlemény hasznosítás</label>
                              <Select id="rental_utilization_id" v-model="area.rental_utilization_id"
                                      :options="getRentalUtilizationList"
                                      optionLabel="name" optionValue="id" placeholder="(Kötelező)" fluid></Select>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6 mb-1">
                              <label for="area_numbers_id" class="form-label fw-normal">Helység száma</label>
                              <Select id="area_numbers_id" v-model="computedAreaNumbersId" :options="getAreaNumbersList"
                                      optionLabel="name" optionValue="id" placeholder="(Kötelező)" class="w-100"/>
                            </div>
                            <div class="col-md-6 mb-1">
                              <label for="area_functions_id" class="form-label fw-normal">Helység funkció</label>
                              <Select id="area_functions_id" v-model="computedFunctionId"
                                      :options="getAreaFunctionsList" optionLabel="name" optionValue="id"
                                      placeholder="(Kötelező)" class="w-100"/>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6 mb-1">
                              <label for="description" class="block font-bold mb-3"
                                     style="display: block; font-weight: 700;">Nettó alapterület
                                [m2]</label>
                              <InputText id="net_floor_space" v-model.trim="area.net_floor_space" required="true"
                                         autofocus :invalid="submitted && !area.net_floor_space" fluid
                                         placeholder="(Kötelező)"/>
                              <small v-if="submitted && !area.net_floor_space" class="text-red-500">Nettó terület
                                szükséges..</small>
                            </div>
                            <div class="col-md-6 mb-1">
                              <label for="description" class="block font-bold mb-3"
                                     style="display: block; font-weight: 700;">Bruttó alapterület
                                [m2]</label>
                              <InputText id="gross_floor_space" v-model.trim="area.gross_floor_space" required="true"
                                         autofocus :invalid="submitted && !area.gross_floor_space" fluid
                                         placeholder="(Kötelező)"/>
                              <small v-if="submitted && !area.gross_floor_space" class="text-red-500">Bruttó alapterület
                                szükséges.</small>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6 mb-1">
                              <label for="area_buildings_id" class="block font-bold mb-3"
                                     style="display: block; font-weight: 700;">Épület
                                szám</label>
                              <Select id="area_buildings_id" v-model="computedBuildingId" :options="getBuildingsList"
                                      optionLabel="name" optionValue="id" placeholder="(Kötelező)" fluid></Select>
                            </div>
                            <div class="col-md-6 mb-1">
                              <label for="area_positions_id" class="block font-bold mb-3"
                                     style="display: block; font-weight: 700;">Pozíció</label>
                              <Select id="area_positions_id" v-model="computedPositionId"
                                      :options="getAreaPositionsList"
                                      optionLabel="name" optionValue="id" placeholder="(Kötelező)" fluid></Select>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6 mb-1">
                              <label for="description" class="block font-bold mb-3"
                                     style="display: block; font-weight: 700;">Helyrajzi
                                szám</label>
                              <InputText id="lot_number" v-model.trim="area.lot_number" required="true" autofocus
                                         :invalid="submitted && !area.lot_number" fluid placeholder="(Kötelező)"/>
                              <small v-if="submitted && !area.lot_number" class="text-red-500">Helyrajzi szám
                                szükséges.</small>
                            </div>
                            <div class="col-md-6 mb-1">
                              <label for="area_floor_coverings_id" class="block font-bold mb-3"
                                     style="display: block; font-weight: 700;">Falszerkezet</label>
                              <Select id="area_floor_coverings_id" v-model="computedWallCoveringsId"
                                      :options="getWallStructuresList" optionLabel="name" optionValue="id"
                                      placeholder="(Opcionális)" fluid></Select>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-6 mb-1">
                              <label for="description" class="block font-bold mb-3"
                                     style="display: block; font-weight: 700;">Belmagasság
                                [m]</label>
                              <InputText id="height" v-model.trim="area.height" required="true" autofocus
                                         :invalid="submitted && !area.height" fluid placeholder="(Opcionális)"/>
                              <small v-if="submitted && !area.height" class="text-red-500">Belmagasság
                                szükséges.</small>
                            </div>
                            <div class="col-md-6 mb-1">
                              <label for="area_floor_coverings_id" class="block font-bold mb-3"
                                     style="display: block; font-weight: 700;">Burkolat</label>
                              <Select id="area_floor_coverings_id" v-model="computedFloorCoveringsId"
                                      :options="getAreaFloorCoveringsList" optionLabel="name" optionValue="id"
                                      placeholder="(Kötelező)" fluid></Select>
                            </div>
                          </div>
                        </div>

                        <template #footer>
                          <Button label="Mégse" icon="pi pi-times" text @click="hideDialog"/>
                          <Button label="Mentés" icon="pi pi-check" :loading="loading" @click="savearea"/>
                        </template>
                      </Dialog>

                      <Dialog v-model:visible="deleteareaDialog" :style="{ width: '450px' }" header="Megerősítés"
                              :modal="true">
                        <div class="flex items-center gap-4">
                          <i class="pi pi-exclamation-triangle !text-3xl"/>
                          <span v-if="area">Biztos vagy benne, hogy törlöd a <b>{{ area.area_nr }}</b> helységet?</span>
                        </div>
                        <template #footer>
                          <Button label="No" icon="pi pi-times" text @click="deleteareaDialog = false">Nem</Button>
                          <Button label="Yes" icon="pi pi-check" @click="deletearea">Igen</Button>
                        </template>
                      </Dialog>

                      <Dialog v-model:visible="deleteareasDialog" :style="{ width: '450px' }" header="Megerősítés"
                              :modal="true">
                        <div class="flex items-center gap-4">
                          <i class="pi pi-exclamation-triangle !text-3xl"/>
                          <span v-if="area">Biztos vagy benne, hogy törlöd a kijelölt helységeket?</span>
                        </div>
                        <template #footer>
                          <Button label="No" icon="pi pi-times" text @click="deleteareasDialog = false">Nem</Button>
                          <Button label="Yes" icon="pi pi-check" text @click="deleteSelectedareas">Igen</Button>
                        </template>
                      </Dialog>
                    </div>
                  </CCardBody>
                </CCard>
              </CCollapse>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormDropDown from "@/components/FormDropdown.vue";
import {onMounted, ref} from 'vue';
import {CButton, CCard, CCardBody, CCollapse} from '@coreui/vue-pro';
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialInput from "@/components/MaterialInput.vue";
import ValidationError from "@/components/ValidationError.vue";
import Modal from "@/components/Modal";
import formMixin from "@/mixins/formMixin.js";
import showSwal from "../../../mixins/showSwal";
import {FilterMatchMode} from '@primevue/core/api';
import {useRoute} from 'vue-router';
import MergeRealEstatesAreasModal from "./components/MergeRealEstatesAreasModal.vue";
import SeparateRealEstatesAreasModal from "./components/SeparateRealEstatesAreasModal.vue";

export default {
  name: 'EditRealEstateAreas',
  components: {
    MaterialButton,
    MaterialInput,
    ValidationError,
    CButton,
    CCollapse,
    CCard,
    CCardBody,
    Modal,
    FormDropDown,
    MergeRealEstatesAreasModal,
    SeparateRealEstatesAreasModal,
  },
  mixins: [formMixin],
  setup() {
    const visible = ref(true);
    const isModalForMergeOpen = ref(false);
    const isModalForSeparateOpen = ref(false);
    const selectedareas = ref(null);
    const realestateId = ref(null);
    const route = useRoute();

    onMounted(() => {
      realestateId.value = route.params.id;
    });

    const openModal = (selectedareas) => {
      if (selectedareas.length > 1) {
        isModalForMergeOpen.value = true;
      } else {
        isModalForSeparateOpen.value = true;
      }
    };

    const closeModal = () => {
      isModalForMergeOpen.value = false;
      isModalForSeparateOpen.value = false;
    };

    return {
      visible,
      color: '#33e8f5',
      isModalForMergeOpen,
      isModalForSeparateOpen,
      selectedareas,
      openModal,
      closeModal,
      realestateId,
    }
  },
  data() {
    return {
      data: [],
      realestate: {},
      areas: [],
      countries: {},
      owners: {},
      sfunctions: {},
      handlings: {},
      newArea: {},
      selected: null,
      areaDialog: false,
      deleteareaDialog: false,
      deleteareasDialog: false,
      area: {},
      selectedareas: null,
      filters: {},
      submitted: false,
      loading: false,
      selectedColumns: null,
      columns: null,
      previewImages: [],
      realEstateImages: [],
      modalVisible: false,
      selectedImage: null,
      filteredColums: null,
    }
  },
  created() {
    this.initFilters();
    this.columns = [
      {field: 'identifier', header: 'Azonosító'},
      {field: 'rental_utilization', header: 'Hasznosítás'},
      {field: 'area_numbers_id', header: 'Helység'},
      {field: 'area_functions_id', header: 'Funkció'},
      {field: 'net_floor_space', header: 'Terület[N]'},
      {field: 'gross_floor_space', header: 'Terület[B]'},
      {field: 'area_buildings_id', header: 'Épület'},
      {field: 'area_positions_id', header: 'Pozíció'},
      {field: 'lot_number', header: 'Helyrajzi szám'},
      {field: 'wall_structure_id', header: 'Falszerkezet'},
      {field: 'height', header: 'Magasság'},
      {field: 'area_floor_coverings_id', header: 'Burkolat'},
    ];
    this.selectedColumns = this.columns;
    this.filteredColums = this.columns.filter(col =>
        [
          'identifier',
          'rental_utilization',
          'area_functions_id',
          'area_numbers_id',
          'gross_floor_space',
          'height',
          'wall_structure_id',
          'gross_floor_space',
          'net_floor_space',
        ].includes(col.field)
    );
  },
  computed: {
    gethandlingList() {
      const data = this.$store.getters["handlings/getHandlingsData"] ?? [];
      return data.map(item => ({
        value: item.id,
        label: item.name
      }));
    },
    getAreaPositionsList() {
      return this.$store.getters["positions/getPositionsData"];
    },
    getWallStructuresList() {
      return this.$store.getters["wallstructures/getWallStructuresData"];
    },
    getAreaNumbersList() {
      return this.$store.getters["areanumbers/getAreanumbersData"];
    },
    getRentalUtilizationList() {
      return this.$store.getters["rentalutilization/getRentalUtilizationData"];
    },
    getBuildingsList() {
      return this.$store.getters["buildings/getBuildingsData"];
    },
    areaPositionsList() {
      const data = this.getAreaPositionsList ?? [];
      return data.map(item => ({
        value: item.id,
        label: item.name
      }));
    },
    getAreaFunctionsList() {
      return this.$store.getters["afunctions/getFunctionsData"];
    },
    getAreaFloorCoveringsList() {
      return this.$store.getters["coverings/getCoveringsData"];
    },
    getRealestateList() {
      return this.$store.getters["realestates/getRealEstatesData"];
    },
    computedBuildingId: {
      get() {
        if (this.area.area_buildings_id) {
          return this.area.area_buildings_id.toString()
        }
      },
      set(val) {
        this.area.area_buildings_id = Number(val)
      }
    },
    computedAreaNumbersId: {
      get() {
        if (this.area.area_numbers_id) {
          return this.area.area_numbers_id.toString()
        }
      },
      set(val) {
        this.area.area_numbers_id = Number(val)
      }
    },
    computedFunctionId: {
      get() {
        if (this.area.area_functions_id) {
          return this.area.area_functions_id.toString()
        }
      },
      set(val) {
        this.area.area_functions_id = Number(val)
      }
    },
    computedPositionId: {
      get() {
        if (this.area.area_positions_id) {
          return this.area.area_positions_id.toString()
        }
      },
      set(val) {
        this.area.area_positions_id = Number(val)
      }
    },
    computedUtilizationId: {
      get() {
        if (this.area.rental_utilization_id) {
          return this.area.rental_utilization_id.toString()
        }
      },
      set(val) {
        this.area.rental_utilization_id = Number(val)
      }
    },
    computedFloorCoveringsId: {
      get() {
        if (this.area.area_floor_coverings_id) {
          return this.area.area_floor_coverings_id.toString()
        }
      },
      set(val) {
        this.area.area_floor_coverings_id = Number(val)
      }
    },
    computedWallCoveringsId: {
      get() {
        if (this.area.wall_structure_id) {
          return this.area.wall_structure_id.toString()
        }
      },
      set(val) {
        this.area.wall_structure_id = Number(val)
      }
    },
    countCommonArea() {
      return this.areas.filter(area => area.identifier.includes("Közös terület")).length;
    },
    countOperations() {
      return this.areas.filter(area => area.identifier.includes("Üzemeltetés")).length;
    },
  },
  async mounted() {
    try {
      await this.$store.dispatch("realestates/getRealEstate", this.$route.params.id);
      this.realestate = this.$store.getters["realestates/getRealEstate"][0];
      this.realestate.id = this.$route.params.id;
      const otherDataPromises = [
        this.$store.dispatch("buildings/getBuildings"),
        this.$store.dispatch("wallstructures/getWallStructures"),
        this.$store.dispatch("areanumbers/getAreanumbers"),
        this.$store.dispatch("rentalutilization/getRentalUtilization"),
        this.$store.dispatch("positions/getPositions"),
        this.$store.dispatch("afunctions/getFunctions"),
        this.$store.dispatch("coverings/getCoverings"),
      ];

      await Promise.all(otherDataPromises);

      if (this.realestate.areas.length > 0) {
        this.realestate.areas.forEach((owner) => {
          this.areas.push({
            id: owner.id,
            identifier: owner.identifier,
            rental_utilization_id: owner.rental_utilization_id,
            rental_utilization: this.getRentalUtilizationList.find(val => val.id == owner.rental_utilization_id)?.name,
            area_buildings_id: owner.area_buildings_id,
            area_buildings: this.getBuildingsList.filter(val => val.id == owner.area_buildings_id),
            area_numbers_id: owner.area_numbers_id,
            area_numbers: this.getAreaNumbersList.filter(val => val.id == owner.area_numbers_id),
            lot_number: owner.lot_number,
            area_positions_id: owner.area_positions_id,
            area_position: this.getAreaPositionsList.filter(val => val.id == owner.area_positions_id),
            area_functions_id: owner.area_functions_id,
            area_function: this.getAreaFunctionsList.filter(val => val.id == owner.area_functions_id),
            net_floor_space: owner.net_floor_space,
            gross_floor_space: owner.gross_floor_space,
            height: owner.height,
            wall_structure_id: owner.wall_structure_id,
            area_wall_structures: this.getWallStructuresList.filter(val => val.id == owner.wall_structure_id),
            area_floor_coverings_id: owner.area_floor_coverings_id,
            area_floor_covering: this.getAreaFloorCoveringsList.filter(val => val.id == owner.area_floor_coverings_id),
          });
        });
      }

      this.loading = false;

    } catch (error) {
      console.error("Error loading data:", error);
      showSwal.methods.showSwal({
        type: "error",
        message: error,
        width: 500
      });
    }
  },
  methods: {
    calculateFilledArea(areas) {
      if (!areas) return 0;
      const sum = areas.reduce((sum, area) => {
        return sum + (parseFloat(area.gross_floor_space) || 0);
      }, 0);
      return Number(sum.toFixed(1));
    },
    calculateRentableUnits(areas) {
      if (!areas) return 0;
      return areas.filter(area => {
        const rentalUtilization = this.getRentalUtilizationList.find(ru => String(ru.id) === String(area.rental_utilization_id));
        return rentalUtilization && rentalUtilization.type === "rentable";
      }).length;
    },
    calculateCommonArea(areas) {
      if (!areas) return 0;
      return areas.reduce((sum, area) => {
        const rentalUtilization = this.getRentalUtilizationList.find(ru => String(ru.id) === String(area.rental_utilization_id));
        if (rentalUtilization && rentalUtilization.type === "public") {
          return sum + (parseFloat(area.net_floor_space) || 0);
        }
        return sum;
      }, 0);
    },
    calculateUtilization(realestate) {
      const deedSize = parseFloat(realestate.deed_size) || 0;
      const grossSize = parseFloat(realestate.gross_size) || 0;

      if (grossSize === 0) return 0;
      return Math.round((deedSize / grossSize) * 100);
    },
    calculateRentableArea(areas) {
      if (!areas) return 0;
      return areas.reduce((sum, area) => {
        const rentalUtilization = this.getRentalUtilizationList.find(ru => String(ru.id) === String(area.rental_utilization_id));
        if (rentalUtilization && rentalUtilization.type === "rentable") {
          return sum + (parseFloat(area.net_floor_space) || 0);
        }
        return sum;
      }, 0);
    },
    calculateOperationalArea(areas) {
      if (!areas) return 0;
      return areas.reduce((sum, area) => {
        const rentalUtilization = this.getRentalUtilizationList.find(ru => String(ru.id) === String(area.rental_utilization_id));
        if (rentalUtilization && rentalUtilization.type === "maintenance") {
          return sum + (parseFloat(area.net_floor_space) || 0);
        }
        return sum;
      }, 0);
    },
    calculateProcessingRate(realestate, areas) {
      if (!areas) return 0;

      const filledArea = areas.reduce((sum, area) => {
        return sum + (parseFloat(area.gross_floor_space) || 0);
      }, 0);

      const grossSize = parseFloat(realestate.gross_size) || 0;

      if (grossSize === 0) return 0;
      return Math.round((filledArea / grossSize) * 100);
    },
    formatArea(value) {
      return `${value} m2`;
    },
    formatPercentage(value) {
      return `${value}%`;
    },
    formatDate(date) {
      if (!date) return '';
      return new Date(date).toLocaleDateString('hu-HU');
    },
    async refreshRealEstateData() {
      try {
        await this.$store.dispatch("realestates/getRealEstate", this.realestate.id);
        this.realestate = this.$store.getters['realestates/getRealEstate'][0];
      } catch (error) {
        console.log("Error in refreshing the realestate data:", error);
      }
    },
    addNewArea(newArea) {
      this.area.id = newArea.id;
      this.area.identifier = newArea.identifier;
      this.area.lot_number = newArea.lot_number;
      this.area.net_floor_space = newArea.net_floor_space;
      this.area.gross_floor_space = newArea.gross_floor_space;
      this.area.height = newArea.height;
      this.area.rental_utilization_id = newArea.rental_utilization_id;
      this.area.realestate_id = newArea.realestate_id;
      this.area.area_buildings = this.getBuildingsList.filter(val => val.id == newArea.area_buildings_id);
      this.area.area_numbers = this.getAreaNumbersList.filter(val => val.id == newArea.area_numbers_id);
      this.area.area_position = this.getAreaPositionsList.filter(val => val.id == newArea.area_positions_id);
      this.area.area_function = this.getAreaFunctionsList.filter(val => val.id == newArea.area_functions_id);
      this.area.area_floor_covering = this.getAreaFloorCoveringsList.filter(val => val.id == newArea.area_floor_coverings_id);
      this.areas.push(this.area);
      this.refreshRealEstateData();
    },
    addNewAreas(savedAreas) {
      savedAreas.forEach(newArea => {
        let area = {};
        area.id = newArea.id;
        area.identifier = newArea.identifier;
        area.lot_number = newArea.lot_number;
        area.net_floor_space = newArea.net_floor_space;
        area.gross_floor_space = newArea.gross_floor_space;
        area.rental_utilization_id = newArea.rental_utilization_id;
        area.height = newArea.height;
        area.realestate_id = newArea.realestate_id;
        area.area_buildings = this.getBuildingsList.filter(val => val.id == newArea.area_buildings_id);
        area.area_numbers = this.getAreaNumbersList.filter(val => val.id == newArea.area_numbers_id);
        area.area_position = this.getAreaPositionsList.filter(val => val.id == newArea.area_positions_id);
        area.area_function = this.getAreaFunctionsList.filter(val => val.id == newArea.area_functions_id);
        area.area_floor_covering = this.getAreaFloorCoveringsList.filter(val => val.id == newArea.area_floor_coverings_id);
        this.areas.push(area);
      });
      this.refreshRealEstateData();
    },
    editAreaNetGrossFloorSpace(editedArea) {
      const areaToEdit = this.areas.find(area => area.id === editedArea.id);
      if (areaToEdit) {
        areaToEdit.net_floor_space = editedArea.net_floor_space;
        areaToEdit.gross_floor_space = editedArea.gross_floor_space;
      }
    },
    deleteOldAreas(areaIds) {
      this.areas = this.areas.filter(area => !areaIds.includes(area.id));
    },
    openNew() {
      this.area = {};
      this.submitted = false;
      this.areaDialog = true;
    },
    hideDialog() {
      this.areaDialog = false;
      this.submitted = false;
    },
    async savearea() {
      this.loading = true
      this.submitted = true;
      if (this.area.id) {
        this.area.id = this.area.id.toString();
        this.area.realestate_id = this.realestate.id;
        try {
          console.log("Saving area:", this.area);
          await this.$store.dispatch("areas/editArea", this.area);

          this.area.area_buildings = this.getBuildingsList.filter(val => val.id == this.area.area_buildings_id);
          this.area.area_numbers = this.getAreaNumbersList.filter(val => val.id == this.area.area_numbers_id);
          this.area.area_position = this.getAreaPositionsList.filter(val => val.id == this.area.area_positions_id);
          this.area.area_function = this.getAreaFunctionsList.filter(val => val.id == this.area.area_functions_id);
          this.area.rental_utilization = this.getRentalUtilizationList.find(val => val.id == this.area.rental_utilization_id);
          this.area.area_floor_covering = this.getAreaFloorCoveringsList.filter(val => val.id == this.area.area_floor_coverings_id);

          this.areas[this.findIndexById(this.area.id)] = this.area;
          this.$toast.add({severity: 'success', summary: 'Sikeres', detail: 'Helység módosítva!', life: 3000});
          this.refreshRealEstateData();
        } catch (error) {
          this.$toast.add({severity: 'error', summary: 'HIBA', detail: error, life: 10000});
          this.areaDialog = false;
          this.area = {};
          this.loading = false
        }
      } else {
        this.area.realestate_id = this.realestate.id;
        try {
          const areaID = await this.$store.dispatch("areas/addArea", this.area);
          this.area.id = areaID.toString();

          this.area.area_buildings = this.getBuildingsList.filter(val => val.id == this.area.area_buildings_id);
          this.area.area_numbers = this.getAreaNumbersList.filter(val => val.id == this.area.area_numbers_id);
          this.area.area_position = this.getAreaPositionsList.filter(val => val.id == this.area.area_positions_id);
          this.area.rental_utilization = this.getRentalUtilizationList.find(val => val.id == this.area.rental_utilization_id);
          this.area.area_function = this.getAreaFunctionsList.filter(val => val.id == this.area.area_functions_id);
          this.area.area_floor_covering = this.getAreaFloorCoveringsList.filter(val => val.id == this.area.area_floor_coverings_id);

          this.areas.push(this.area);
          this.$toast.add({severity: 'success', summary: 'Sikeres', detail: 'Helység hozzáadva!', life: 3000});
          this.refreshRealEstateData();
        } catch (error) {
          this.$toast.add({severity: 'error', summary: 'HIBA', detail: error, life: 10000});
          this.areaDialog = false;
          this.area = {};
          this.loading = false
        }
      }

      this.areaDialog = false;
      this.area = {};
      this.loading = false;
    },
    editarea(area) {
      this.area = {...area};
      this.areaDialog = true;
    },
    confirmDeletearea(area) {
      this.area = area;
      this.deleteareaDialog = true;
    },
    async deletearea() {
      this.areas = this.areas.filter(val => val.id !== this.area.id);
      this.deleteareaDialog = false;
      await this.$store.dispatch("areas/deleteArea", this.area.id);
      this.area = {};
      this.refreshRealEstateData();
      this.$toast.add({severity: 'success', summary: 'Successful', detail: 'area Deleted', life: 3000});
    },
    findIndexById(id) {
      let index = -1;
      for (let i = 0; i < this.areas.length; i++) {
        if (this.areas[i].id == id) {
          index = i;
          break;
        }
      }

      return index;
    },
    confirmDeleteSelected() {
      this.deleteareasDialog = true;
    },
    deleteSelectedareas() {
      this.areas = this.areas.filter(val => !this.selectedareas.includes(val));
      this.deleteareasDialog = false;
      this.selectedareas = null;
      this.$toast.add({severity: 'success', summary: 'Successful', detail: 'areas Deleted', life: 3000});
    },
    initFilters() {
      this.filters = {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
      }
    },
    async handleEdit() {
      this.loading = true
      this.resetApiValidation();
      try {
        this.realestate.deed_size = parseFloat(this.realestate.deed_size);
        this.realestate.gross_size = parseFloat(this.realestate.gross_size);
        this.realestate.areas = this.areas;
        await this.$store.dispatch("realestates/editRealEstate", this.realestate);
        showSwal.methods.showSwal({
          type: "success",
          message: "Ingatlan sikeresen módosítva!",
          width: 500
        });
        this.$router.push({name: "RealEstates List"})
      } catch (error) {
        if (error.response.data.errors) {
          this.setApiValidation(error.response.data.errors);
        }
        showSwal.methods.showSwal({
          type: "error",
          message: "Valami hiba történt!",
          width: 500
        });

      }
      this.loading = false
    },
    addArea(type, value) {
      if (type == 'commissioning_date') {
        this.newArea[type] = this.format(value);
      } else if (type == 'area_buildings_id' || type == 'area_numbers_id' || type == 'area_functions_id' || type == 'area_positions_id' || type == 'area_floor_coverings_id') {
        this.newArea[type] = Number(value);
      } else if (type == 'net_floor_space' || type == 'gross_floor_space' || type == 'height') {
        this.newArea[type] = parseFloat(value);
      } else {
        this.newArea[type] = value;
      }
    },
    onToggle(value) {
      this.selectedColumns = this.columns.filter(col => value.includes(col));
    }
  }
}
</script>